import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { Link } from "react-router";
import { CTAWrapper } from "./components/CTA";
import { formatRichText, replacePricesInString } from "./functions/richText";
import { TileListContent } from "./sections/tiles/TileListPageSection";
import { contentfulToCTA, contentfulToImageData, formatCTAS, getSectionStyling, getTokenValue } from "./functions";

const CONFIGURED_CONTENT_TYPES = {
	ctaButton: "ctaButton",
	paragraph: "paragraph",
	tileListPageSection: "tileListPageSection",
	token: "token",
};

export const createRenderOptions = (siteStatus = {}, parsedFunctions = {}, isStatic = false) => ({
	renderNode: {
		[BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
			const { fields } = node.data.target || {};
			switch (node.data.target.sys.contentType.sys.id) {
				case CONFIGURED_CONTENT_TYPES.ctaButton:
					return (
						<div className="my-4 md:flex md:justify-center lg:justify-start">
							<CTAWrapper cta={{ ...fields, isStatic }} parsedFunctions={parsedFunctions} />
						</div>
					);
				case CONFIGURED_CONTENT_TYPES.paragraph: {
					const formattedRichText = formatRichText(fields.paragraph, siteStatus);
					return (
						<div className="my-4">
							<p className="text-lg">{formattedRichText}</p>
						</div>
					);
				}
				case CONFIGURED_CONTENT_TYPES.tileListPageSection: {
					const formattedSectionStyles = getSectionStyling(fields.sectionStyles, fields.variant);
					return (
						<TileListContent
							{...fields}
							formattedSectionStyles={formattedSectionStyles}
							siteStatus={siteStatus}
							parsedFunctions={parsedFunctions}
							isVertical={true}
							isEmbedded={true}
						/>
					);
				}
				default:
					return children;
			}
		},
		[BLOCKS.EMBEDDED_ASSET]: node => {
			const { title, file } = node.data.target.fields;
			return (
				<div className="m-auto">
					<img src={file.url} alt={title} className="max-w-full h-auto m-auto" />
				</div>
			);
		},

		[BLOCKS.UL_LIST]: (node, children) => {
			return (
				<ul className="list-disc pl-4 marker:pr-1 [&_li]:mb-2">
					{children}
				</ul>
			);
		},
		[INLINES.HYPERLINK]: (node, children) => {
			const url = node.data.uri;
			const isHttpUrl = typeof url === "string" && /^https?:\/\//i.test(url);
			const ownHosts = [
				"www.instantscripts.com.au",
				"app.instantscripts.com.au",
				typeof window !== "undefined" ? window.location.host : null,
			].filter(Boolean);

			if (isHttpUrl) {
				const parsed = new URL(url);
				if (ownHosts.includes(parsed.host)) {
					// Strip domain so internal links stay within the current environment
					const relativePath = parsed.pathname + parsed.search + parsed.hash;
					return <Link to={relativePath}>{children}</Link>;
				}
			}

			return (
				<a href={url} target="_blank" rel="noopener noreferrer">
					{children}
				</a>
			);
		},
		[INLINES.EMBEDDED_ENTRY]: (node, children) => {
			const { parsedFunctions, fields } = node.data.target || {};
			switch (node.data.target.sys.contentType.sys.id) {
				case CONFIGURED_CONTENT_TYPES.ctaButton:
					const field = {...fields, icon: fields?.icon ? contentfulToImageData(fields?.icon) : null}
					return (
						<CTAWrapper cta={{ ...field }} parsedFunctions={parsedFunctions ?? {}} inline />
					);
				case CONFIGURED_CONTENT_TYPES.token: {
					const value = getTokenValue(node.data.target);
					return <span>{replacePricesInString(value ?? "", siteStatus)}</span>;
				}
				default:
					return children;
			}
		},
	},
	preserveWhitespace: true,
});
